{
  "Use AirPlay": "Utilisar AirPlay"
}
